import LegalLayout from '../components/layouts/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="October 13, 2026">
      <p>
        These Terms of Service ("Terms") govern your use of EextraMile (the "Service"), operated by Raj Motwani ("we", "us", "our"). By creating an
        account or using the Service, you agree to these Terms. If you don't agree, don't use the Service.
      </p>

      <h2>1. What EextraMile does</h2>
      <p>
        EextraMile helps job seekers find recruiter contacts at companies they've applied to, and drafts or
        sends personalized outreach emails on their behalf using the user's own connected Gmail account. The
        Service also monitors the user's Gmail inbox (with permission) to detect job-application confirmation
        emails, bounces, and replies, and can send automated follow-up emails after a period of no response.
      </p>

      <h2>2. Your account</h2>
      <p>
        You must sign in with a Google account and grant the Gmail permissions the Service requests to use
        it. You're responsible for keeping your account secure and for all activity under it. You must be at
        least 18 years old (or the age of majority in your jurisdiction) to use the Service.
      </p>

      <h2>3. Acceptable use — you agree not to:</h2>
      <ul>
        <li>Use the Service to send unsolicited bulk email, spam, or content that violates the CAN-SPAM Act or equivalent anti-spam laws in your jurisdiction.</li>
        <li>Impersonate any person or company, or misrepresent your identity or qualifications in outreach emails.</li>
        <li>Use the Service to harass, threaten, or send abusive content to any recruiter or third party.</li>
        <li>Attempt to circumvent credit limits, rate limits, or plan restrictions.</li>
        <li>Use the Service for any purpose other than legitimate job-search outreach.</li>
        <li>Reverse-engineer, scrape, or attempt to extract the Service's underlying data (including the shared recruiter/company database) for resale or unrelated purposes.</li>
      </ul>
      <p>
        We may suspend or terminate accounts that violate this section, with or without notice, and without
        a refund of unused credits.
      </p>

      <h2>4. Credits, plans, and billing</h2>
      <p>
        Outreach emails are metered using a credit system. Credits are consumed when an email is sent to a
        recruiter, at the rate described on our <a href="/pricing">pricing page</a>. Paid credit packs and
        subscription plans are processed through Razorpay. Credits do not expire, but they are non-refundable
        once purchased, except where required by law. We may change plan pricing or features with notice
        posted on this page or communicated to your account email.
      </p>

      <h2>5. Your content and responsibility for outreach</h2>
      <p>
        You control what background information, resume content, and tone settings the Service uses to
        generate outreach emails. You are solely responsible for the accuracy of the information you provide
        and for the content of any email sent from your Gmail account through the Service, whether drafted
        for your review or sent automatically on your behalf under a "Send Now" or automated follow-up
        setting. We are not responsible for the accuracy of recruiter contact information sourced from public
        web searches, which may be outdated or incorrect.
      </p>

      <h2>6. Third-party services</h2>
      <p>
        The Service relies on third-party providers to function, including Google (Gmail API, sign-in),
        Anthropic (to draft email content and classify emails), OpenAI (to read uploaded resumes), Google Custom
        Search and Hunter.io (to find and verify recruiter contacts), and Razorpay (payments). Your use of the
        Service is also subject to those providers' own terms where applicable. We are not responsible for
        outages, errors, or policy changes on the part of these third parties.
      </p>

      <h2>7. Disclaimers</h2>
      <p>
        The Service is provided "as is" without warranties of any kind. We do not guarantee that any number
        of recruiters will be found for a given company, that outreach emails will receive a response, or
        that the Service will be uninterrupted or error-free. Recruiter discovery depends on third-party
        search indexes outside our control and results will vary by company.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, Raj Motwani will
        not be liable for any indirect, incidental, special, or consequential damages arising from your use of
        the Service, including damages resulting from emails sent on your behalf, missed opportunities, or
        third-party service outages. Our total liability for any claim relating to the Service will not
        exceed the amount you paid us in the 12 months before the claim arose.
      </p>

      <h2>9. Termination</h2>
      <p>
        You may delete your account at any time from Settings, which permanently removes your data and
        revokes the Service's access to your Gmail account. We may suspend or terminate your account for
        violation of these Terms, non-payment, or extended inactivity, with reasonable notice where practical.
      </p>

      <h2>10. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. If we make material changes, we'll update the "Last
        updated" date above and, where required, notify you by email. Continued use of the Service after a
        change means you accept the updated Terms.
      </p>

      <h2>11. Governing law</h2>
      <p>
        These Terms are governed by the laws of the State of Maharashtra, India,
        without regard to conflict-of-law principles.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about these Terms? Contact us at{' '}
        <a href="mailto:eextramileai@gmail.com">eextramileai@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
